export default __webpack_public_path__ + "static/media/choju4.7cac3746.mp4";